<template>
    <el-container>
        <td-permission :permissions="permissionsView">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree">
                    <td-tree
                        :lazyloading="lazyloading"
                        :draggable="draggable"
                        :isDbClick="true"
                        :calInternal="true"
                        :isClick="true"
                        :imgloading="true"
                        :typeContent="typeContent"
                        :checkStrictly="false"
                        @onDbClick="onDbClickTree"
                        @onClick="onDbClickTree"
                        :checkNodes="checkNodes"
                        :dragLevel="true"
                        :isPaging="true"
                        :parentOrgIds="parentOrgId"
                        :orgTypeIds="orgTypeIds"
                        :defaultProps="defaultProps"
                        :nodeKey="nodeKey"
                        :interfaceName="interfaceName"
                        :params="params"
                        @nodeDrop="nodeDrop"
                        ref="TdTree"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container>
            <el-header>
                <td-permission :permissions="permissionsView" style="width:100%;">
                    <div slot="havePermission" style="width:100%;height:auto;">
                        <el-form :inline="true" style="width:100%;">
                            <div style="width:100%;">
                                <el-row style="margin-top:10px;">
                                    <el-col :span="10001">
                                        <div class="userModuleInfoLogo"></div>
                                    </el-col>
                                    <el-col :span="10023" style="margin-left:10px;">
                                        <div style="font-weight:bold;">{{ $t('common.BASE_INFO') }}</div>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-bottom:20px;margin-top:10px;">
                                    <el-form-item :label="$t('common.NAME')" style="padding-right:10px;">
                                        <td-input width="180" v-model="baseInfo.name" :disabled="true" data-toggle="tooltip"> </td-input>
                                    </el-form-item>
                                    <el-form-item style="padding-left:0px;margin-top:0px;">
                                        <td-button type="button" size="medium" :permissions="permissionsEdit" @click="btnEdit" :disabled="baseInfo.name === '' || baseInfo.name === null">{{
                                            $t('pgCommon.EDIT')
                                        }}</td-button>
                                        <td-button type="button" size="medium" :permissions="permissionsDel" @click="btnDelete" :disabled="baseInfo.name === '' || baseInfo.name === null">{{
                                            $t('pgCommon.DELETE')
                                        }}</td-button>
                                        <td-button type="button" size="medium" :permissions="permissionsImport" @click="btnImport">{{ $t('pgCommon.IMPORT') }}</td-button>
                                        <td-button type="button" size="medium" :loading="exportLoadding" :permissions="permissionsExport" @click="btnExport">{{ $t('pgCommon.EXPORT') }}</td-button>
                                    </el-form-item>
                                </el-row>
                            </div>
                        </el-form>
                    </div>
                </td-permission>
            </el-header>
            <el-main style="padding-bottom: 0px;">
                <td-permission :permissions="permissionsView" style="width:100%;">
                    <div slot="havePermission">
                        <el-tabs v-model="selectTabsValue.name" type="card" @tab-click="handleClick">
                            <el-tab-pane :key="selectTabsValue.name" :label="selectTabsValue.title" :name="selectTabsValue.name">
                                <el-row class="marginBottom10" style="margin-top:15px;">
                                    <el-col :span="9">
                                        <td-button type="primary" size="medium" :permissions="permissionsAdd" @click="onClickAdd">{{ $t('pgCommon.ADD') }}</td-button>
                                        <td-button size="medium" :permissions="permissionsDel" @click="onClickBatchDelete">{{ $t('pgCommon.DELETE_BATCH') }}</td-button>
                                    </el-col>
                                </el-row>
                                <el-row style="height:500px">
                                    <td-table
                                        :columns="columns"
                                        :dataSource="tableData"
                                        :pageSize="pageSize"
                                        :currentPage="currentPage"
                                        :total="total"
                                        :hasLoading="loading"
                                        :rowKey="sId"
                                        :hasMutiSelect="true"
                                        @handleSizeChange="handleSizeChange"
                                        @currentChange="handleCurrentChange"
                                        ref="orgStructure"
                                    >
                                    </td-table>
                                </el-row>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </td-permission>
                <!-- 加载dialog -->
                <dialogOrgStructure
                    v-if="dialogOrgVisible"
                    :isAddData="isAddData"
                    :dialogOrgVisible="dialogOrgVisible"
                    v-on:reciveOrgInfoFromDialog="reciveOrgInfoFromDialog"
                    :editItem="editItem"
                    :editBaseOrg="editBaseOrg"
                    :title="dialogTitle"
                    ref="addOrModifyInfo"
                    :modifyDialogWidth="modifyDialogWidth"
                    @orgDialogClose="orgDialogClose"
                    @queryTabList="queryTabList"
                    @submit="submit"
                ></dialogOrgStructure>
                <dialogStructureImport
                    :title="importTitle"
                    v-if="isImportVisible"
                    :iDeviceTypes="iDeviceTypes"
                    :orgId="orgId"
                    :isImportVisible="isImportVisible"
                    @dlalogImportClose="importClose"
                    @submit="submit"
                ></dialogStructureImport>
                <dialogStructureMessage ref="dialogMsg" v-show="isMsgAvailable" :isMsgAvailable="isMsgAvailable" :title="msgTitle" @dlalogMsgClose="dlalogMsgClose"></dialogStructureMessage>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import orgApi from './assets/api.js';
import dialogOrgStructure from './components/dialogOrgStructure.vue';
import dialogStructureImport from './components/dialogStructureImport.vue';
import dialogStructureMessage from './components/dialogStructureMessage.vue';
export default {
    components: {
        dialogOrgStructure,
        dialogStructureImport,
        dialogStructureMessage
    },

    created() {
        if (document.body.clientWidth >= 1920) {
            this.screenSpan = 4;
        } else if (document.body.clientWidth >= 1600) {
            this.screenSpan = 5;
        } else if (document.body.clientWidth >= 1440) {
            this.screenSpan = 6;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.modifyDialogWidth = 650 + newVal;
            },
            deep: true //对象内部属性的监听，关键。
        },
    },
    mounted() {
        // 是否有拖动排序权限
        let permissionStr = sessionStorage.getItem('stringPermissions');
        if (permissionStr != null && permissionStr != '' && permissionStr != undefined) {
            let permissionList = permissionStr.split(',');
            for (let i = 0; i < permissionList.length; i++) {
                if (permissionList[i] === 'orgStructure:sort') {
                    this.draggable = true;
                }
            }
        }
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    data() {
        return {
            modifyDialogWidth: 610,
            permissionsView: ['orgStructure:view'],
            permissionsAdd: ['orgStructure:add'],
            permissionsDel: ['orgStructure:del'],
            permissionsEdit: ['orgStructure:edit'],
            permissionsImport: ['orgStructure:import'],
            permissionsExport: ['orgStructure:export'],
            lazyloading: true,
            exportLoadding: false,
            draggable: 'false',
            params: {
                currentPage: 1,
                needPage: true,
                pageSize: 50
            },
            checkNodes: [],
            typeContent: [{ sIcon: 'FIRST_CLASS' }, { sIcon: 'SECOND_CLASS' }],
            calInternal: false,
            editBaseOrg: false,
            isClick: true,
            parentOrgId: window.pgCommon.initOrgTreeParam.PARENTORGID,
            orgTypeIds: [window.pangu.common.orgType.ORG_STRUCTURE],
            dialogOrgVisible: false,
            isImportVisible: false,
            isMsgAvailable: false,
            editItem: {},
            screenSpan: 6,
            dialogTitle: '',
            importTitle: '',
            msgTitle: '',
            orgId: '',
            isAddData: true,
            defaultProps: { label: 'caption', id: 'id', children: 'children', imgName: 'sIcon', parentId: 'parentId' },
            nodeKey: 'id',
            interfaceName: { query: '/OrgStructureController/findOrgStructureTree', search: '/OrgStructureController/findOrgStructureTree' },
            columns: [
                {
                    prop: 'sName',
                    label: 'pgCommon.NAME'
                },
                {
                    prop: 'sCode',
                    label: 'pgCommon.ALARM_SERIAL_NUMBER'
                },
                {
                    prop: 'sTypeName',
                    label: 'pgCommon.TYPE',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'pgCommon.OPERATE',
                    tableWidth: '250',
                    align: 'center',
                    render: (createElement, params) => {
                        let b1 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickEdit(params.row, false);
                                    }
                                }
                            },
                            this.$t('pgCommon.EDIT')
                        );
                        let b2 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsDel, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickDelete(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.DELETE')
                        );
                        let isCanDelete = true;
                        if (!this.$util.isEmpty(params.row.sExtendInfo)) {
                            let nodes = JSON.parse(params.row.sExtendInfo.replace(/\\/g, ''));
                            let canDelete = nodes.private_isCanDelete;
                            if (canDelete === '0') {
                                isCanDelete = false;
                            }
                        }
                        let list = [];
                        if (!this.$util.isEmpty(params.row.sDomainType) && params.row.sDomainType != '0') {
                            if (isCanDelete) {
                                list = [b2];
                            } else {
                                list = [];
                            }
                        } else {
                            if (isCanDelete) {
                                list = [b1, b2];
                            } else {
                                list = [];
                            }
                        }
                        return createElement('div', list);
                    }
                }
            ],
            selectTabsValue: {
                name: '2',
                title: window.vue.$t('pgCommon.SON_STRUCTURE')
            },
            baseInfo: {
                name: '',
                type: ''
            },
            tableData: [],
            orgTypes: [],
            pageSize: 10,
            currentPage: 1,
            total: 0,
            loading: false,
            nowTreeItem: null,
            rootTreeItem: null,
            fromOrg: {
                sName: ''
            }
        };
    },
    methods: {
        // 树形双击事件
        onDbClickTree: function(item) {
            this.nowTreeItem = item;
            this.baseInfo.name = item.caption;
            let queryVo = this.getParam(item);
            if (this.rootTreeItem === null) {
                this.rootTreeItem = item;
            }
            //切换树形时，强制切换到第一页
            queryVo.currentPage = 1;
            this.queryData(queryVo);
        },

        // 获取查询参数
        getParam: function(item) {
            let queryVo = {
                needPage: true,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                orgTypeIds: this.params.orgTypeIds,
                unassorted: true
            };
            if (item != null) {
                queryVo.parentOrgIds = item.id;
            }
            queryVo.queryType = window.pangu.common.orgType.ORG_STRUCTURE;
            return queryVo;
        },

        // 查询数据
        queryData: function(queryVo) {
            this.loadings = true;
            let json = JSON.stringify(queryVo);
            orgApi.findOrgStructure(json, response => {
                this.loadings = false;
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.tableData = response.data.content;
                        this.total = response.data.count;
                    }
                }
            });
        },

        // 控制每页条数变化
        handleSizeChange(val) {
            let param = this.getParam(this.nowTreeItem);
            this.pageSize = val;
            param.pageSize = val;
            this.queryData(param, true);
        },

        // 控制页数变化
        handleCurrentChange(val) {
            let param = this.getParam(this.nowTreeItem);
            param.currentPage = val;
            this.currentPage = val;
            this.queryData(param, true);
        },

        // 查询Tab页数据
        queryTabList: function() {
            let param = this.getParam(this.nowTreeItem);
            param.currentPage = this.currentPage;
            param.pageSize = this.pageSize;
            this.queryData(param);
        },

        // 批量删除方法
        deleteOrgs: function(orgIds, deleteItem) {
            let deleteInfo = {
                orgIds: orgIds
            };
            orgApi.deleteOrgStructure(JSON.stringify(deleteInfo), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.$refs.TdTree.editTreeNode(deleteItem, 'delete', this.nowTreeItem);
                        if (orgIds[0] === this.nowTreeItem.orgId) {
                            this.onDbClickTree(this.rootTreeItem);
                        } else {
                            this.queryTabList();
                        }
                    } else {
                        this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    }
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('pgCommon.OPERATION_FAIL') });
                }
            });
        },

        // 编辑
        btnEdit: function() {
            if (this.nowTreeItem.noPermission) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_OPERATE_THIS_NODE'), type: 'warning' });
                return;
            }
            if (!this.$util.isEmpty(this.nowTreeItem.sOrgId) && this.nowTreeItem.sOrgId === window.pangu.common.orgNotAllocationId) {
                this.$message({ showClose: true, message: this.$t('pgMessage.THIS_NODE_CAN_NOT_EDIT'), type: 'warning' });
                return;
            }
            let isCanDelete = true;
            if (!this.$util.isEmpty(this.nowTreeItem.sExtendInfo)) {
                let nodes = JSON.parse(this.nowTreeItem.sExtendInfo.replace(/\\/g, ''));
                let canDelete = nodes.private_isCanDelete;
                if (canDelete === '0') {
                    isCanDelete = false;
                }
            }
            if (!isCanDelete) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_EDIT_THIS_NODE'), type: 'warning' });
                return;
            }
            if (this.nowTreeItem !== null) {
                let queryParam = {
                    needDetail: true,
                    needPage: false,
                    querySingleType: true,
                    orgIdList: [this.nowTreeItem.id],
                    recursiveQuery: true
                };
                orgApi.findOrgStructure(JSON.stringify(queryParam), response => {
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                        if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.onClickEdit(response.data.content[0], true);
                        } else {
                            this.$log.error('/OrgStructureController/findOrgStructure', response.data.statusMessage);
                        }
                    } else {
                        this.$message({ type: 'error', showClose: true, message: this.$t('pgCommon.OPERATION_FAIL') });
                        this.$log.error('/OrgStructureController/findOrgStructure', response);
                    }
                });
            }
        },

        // 基本信息删除
        btnDelete: function() {
            if (this.nowTreeItem.noPermission) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_OPERATE_THIS_NODE'), type: 'warning' });
                return;
            }
            if (!this.$util.isEmpty(this.nowTreeItem.sOrgId) && this.nowTreeItem.sOrgId === window.pangu.common.orgNotAllocationId) {
                this.$message({ showClose: true, message: this.$t('pgMessage.THIS_NODE_CAN_NOT_DELETE'), type: 'warning' });
                return;
            }
            let isCanDelete = true;
            if (!this.$util.isEmpty(this.nowTreeItem.sExtendInfo)) {
                let nodes = JSON.parse(this.nowTreeItem.sExtendInfo.replace(/\\/g, ''));
                let canDelete = nodes.private_isCanDelete;
                if (canDelete === '0') {
                    isCanDelete = false;
                }
            }
            if (!isCanDelete) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_DELETE_THIS_NODE'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS_EX'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteOrgs([this.nowTreeItem.id], [{ parentId: this.nowTreeItem.parentId, id: this.nowTreeItem.id }]);
                    this.onDbClickTree(this.rootTreeItem);
                })
                .catch(e => {
                    this.$log.error('基本信息区域删除', e);
                });
        },

        // table操作编辑
        onClickEdit: function(row, isBaseEdit) {
            this.isAddData = false;
            this.dialogTitle = this.$t('pgCommon.EDIT_ORG_STRUCTURE');
            this.dialogOrgVisible = true;
            this.editItem = row;
            this.editBaseOrg = isBaseEdit;
        },

        // table操作删除
        onClickDelete: function(row) {
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS_EX'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteOrgs([row.sOrgId], [{ parentId: row.sParentId, id: row.sOrgId }]);
                })
                .catch(e => {
                    this.$log.error('table操作删除', e);
                });
        },

        // TAB页添加
        onClickAdd: function(index) {
            if (this.nowTreeItem.noPermission) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_OPERATE_THIS_NODE'), type: 'warning' });
                return;
            }
            this.isAddData = true;
            this.dialogTitle = this.$t('pgCommon.ADD_ORG_STRUCTURE');
            this.dialogOrgVisible = true;
            this.editItem = {
                orgTypeId: this.orgTypes.length === 0 ? null : this.orgTypes[index].orgTypeId,
                sParentId: this.$util.isEmpty(this.nowTreeItem) || this.nowTreeItem.id === window.pangu.common.orgNotAllocationId ? '0' : this.nowTreeItem.id
            };
        },

        // TAB页批量删除
        onClickBatchDelete: function() {
            let rows = this.$refs.orgStructure.getSelectAllRows();
            if (rows.length === 0) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_DELORG') });
                return;
            }
            let orgIds = [];
            let deleteItem = [];
            let isCanDelete = false;
            for (let i = 0; i < rows.length; i++) {
                const element = rows[i];
                if (this.$util.isEmpty(element.sExtendInfo)) {
                    isCanDelete = true;
                } else {
                    let nodes = JSON.parse(element.sExtendInfo.replace(/\\/g, ''));
                    let canDelete = nodes.private_isCanDelete;
                    if (canDelete != '0') {
                        isCanDelete = true;
                    } else {
                        continue;
                    }
                }
                orgIds.push(element.sOrgId);
                let item = { parentId: element.parentOrgId, id: element.sOrgId };
                deleteItem.push(item);
            }
            if (!isCanDelete) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_DELETE_THIS_NODE'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS_EX'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteOrgs(orgIds, deleteItem);
                })
                .catch(e => {
                    this.$log.error('TAB页批量删除', e);
                });
        },

        // 监听dialog，将数据回显到树形
        reciveOrgInfoFromDialog: function(data, editBaseOrg) {
            if (!this.isAddData) {
                if (data.sParentId == 0) {
                    this.$refs.TdTree.editTreeNode([{ parentId: null, id: data.sId }], 'modify', data.sName);
                } else {
                    this.$refs.TdTree.editTreeNode([{ parentId: data.sParentId, id: data.sId }], 'modify', data.sName);
                }
                if (editBaseOrg) {
                    this.baseInfo.name = data.sName;
                }
                return;
            }
            let val = {
                id: data.sId,
                caption: data.sName,
                noPermission: false,
                typeId: data.iType,
                typeName: data.sTypeName,
                parentId: data.sParentId,
                sIcon: data.sIcon
            };
            // 添加根节点，树形操作参数处理
            let parentItem = [];
            let isRefreshTree = false;
            // 如果添加的是根节点或者父节点发生改变，则刷新树形
            if (data.sParentId === '0001' || this.nowTreeItem.id != data.sParentId) {
                isRefreshTree = true;
            }
            let _this = this;
            if (isRefreshTree) {
                // 解决发送mq添加权限慢，立即刷新树形查询不出问题
                setTimeout(function() {
                    _this.$refs.TdTree.initTree();
                }, 1000);
            } else {
                if (this.nowTreeItem.parentId === '0001') {
                    parentItem = [{ parentId: null, id: this.nowTreeItem.id }];
                } else {
                    parentItem = [{ parentId: this.nowTreeItem.parentId, id: this.nowTreeItem.id }];
                }
                // 添加节点回显到树形
                this.$refs.TdTree.editTreeNode(parentItem, 'add', val);
            }
            let queryVo = this.getParam(this.nowTreeItem);
            // 非admin时，添加完组织后向mq发送消息，权限监听mq队列添加组织权限，不能立即添加成功，这里延迟0.5秒查询
            setTimeout(function() {
                _this.queryData(queryVo, false);
            }, 500);
        },

        // 拖拽方法
        nodeDrop: function(dragNode, dropNode, dropType) {
            let queryParam = {
                orgId: dragNode.key
            };
            if (dropType === 'before') {
                queryParam.latterOrgId = dropNode.key;
            } else if (dropType === 'after') {
                queryParam.previousOrgId = dropNode.key;
            }
            orgApi.orgSort(JSON.stringify(queryParam), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ type: 'error', showClose: true, message: this.$t('common.OPERATION_FAIL') });
                        this.$log.error('/OrgManagerController/findTree', response.data.statusMessage);
                    }
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('common.OPERATION_FAIL') });
                    this.$log.error('/OrgManagerController/findTree', response);
                }
            });
        },

        // 导入
        btnImport: function() {
            if (this.nowTreeItem == null) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_BELONG_ORG'), type: 'warning' });
                return;
            }
            this.isImportVisible = true;
            this.orgId = this.nowTreeItem.orgId;
            this.importTitle = this.$t('pgCommon.UPLOAD_ORG_EXCEL');
        },

        // 导出
        btnExport: function() {
            if (this.nowTreeItem == null) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_ORG'), type: 'warning' });
                return;
            }
            this.exportLoadding = true;
            let param = {};
            let responseType = 'arraybuffer';
            orgApi.exportOrgStructureCsv(param, responseType, response => {
                this.exportLoadding = false;
                let blob = new Blob([response.data], { type: 'application/x-xls' });
                this.content = response.data;
                // 汉子解码
                let filename = decodeURIComponent(response.headers['filename']);
                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
            });
        },

        submit: function() {
            let _this = this;
            setTimeout(function() {
                // 刷新树形
                _this.$refs.TdTree.initTree();
                _this.onDbClickTree(this.nowTreeItem);
            }, 500);
        },

        // 关闭dialog树形
        orgDialogClose: function() {
            this.dialogOrgVisible = false;
        },

        // 关闭上传页面
        importClose: function(data) {
            this.isImportVisible = false;
            if (!this.$util.isEmpty(data) && typeof data != 'function' && data.length > 0) {
                this.msgTitle = this.$t('pgCommon.IMPORT_RESULT');
                this.$refs.dialogMsg.setMessage(data);
                this.isMsgAvailable = true;
            }
        },

        // 关闭提示消息页面
        dlalogMsgClose: function() {
            this.isMsgAvailable = false;
        }
    }
};
</script>

<style>
.col-right {
    text-align: right;
    margin-top: 5px;
}
.margin-top20 {
    margin-top: 20px;
}
</style>
<style scoped>
.org-main {
    height: auto;
    padding-top: 10px;
    position: relative;
}
</style>
